import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import styles from "./components/Css/Banner.module.css"; // Importing CSS module

const ImageSlider = () => {
  const images = [
    "../images/home/Banner.png",
    "../images/home/Banner.png",
    "../images/home/Banner.png",
  ];

  return (
    <div className={styles.sliderContainer}>
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000 }}
        loop
        slidesPerView={1}
      >
        {images.map((img, index) => (
          <SwiperSlide key={index} className={styles.slide}>
            <img src={img} alt={`Slide ${index + 1}`} className={styles.image} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ImageSlider;
